import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M18.5 14.5a1.5 1.5 0 003 0v-5A1.5 1.5 0 0020 8h-5a1.5 1.5 0 000 3h3.5v3.5zM12 14a1.5 1.5 0 00-3 0v5.5a1.5 1.5 0 001.5 1.5h5a1.5 1.5 0 000-3H12v-4z" /></svg>);